@if (alternativaHandelssortimentlist && kundorderradHandelssortimentlist) {
  <div class="modal-body destineringdialog-scroll">
    <div>
      <rask-list [data]="alternativaHandelssortimentlist" [fixedHeader]="true" [innerHeader]="true">
        <rask-list-column header="Alternativa handelssortiment" field="mottagningsplatsNamn"></rask-list-column>
        <rask-list-column header="Lägg till / Ta bort" field="">
          <ng-template let-row="row">
            <rask-checkbox
              text=""
              [(ngModel)]="row.laggtill"
              [checked]="">
            </rask-checkbox>
          </ng-template>
        </rask-list-column>
      </rask-list>
    </div>
    <div class="list-padding">
      <rask-list [data]="kundorderradHandelssortimentlist" [fixedHeader]="true" [innerHeader]="true">
        <rask-list-column header="Kundorderrader" field="mottagningsplatsNamn"></rask-list-column>
        <rask-list-column header="Lägg till / Ta bort" field="">
          <ng-template let-row="row">
            <rask-checkbox
              text=""
              [(ngModel)]="row.laggtill"
              [checked]="">
            </rask-checkbox>
          </ng-template>
        </rask-list-column>
      </rask-list>
    </div>
  </div>
}
<div class="modal-footer">
  <rask-button aid="buttonSpara" color="primary" (click)="save()" [disabled]="!canSave()">Spara</rask-button>
  <rask-button aid="buttonAvbryt" color="secondary" (click)="dismiss()" ngbAutofocus>Avbryt</rask-button>
</div>

